import React from 'react';
import { motion } from 'framer-motion';
interface CtaButtonProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
  href?: string;
}
export function CtaButton({
  children,
  fullWidth = false,
  className = '',
  href = 'https://checkout.equilibriodigital.shop/cart/47588015079614:1'
}: CtaButtonProps) {
  const classes = `
    bg-oxblood text-white font-semibold py-4 px-8 rounded-sm
    shadow-sm hover:bg-[#8A3123] transition-colors duration-200
    flex items-center justify-center text-center no-underline
    ${fullWidth ? 'w-full' : 'w-full md:w-auto'}
    ${className}
  `;
  return <motion.a href={href} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={classes} data-id="element-172">
      {children}
    </motion.a>;
}